// state_helpers.js

/**
 * Given a list of Objects, an Object, and a key of the object,
 * update the object within the list should it exist and add to the list
 * should it not. Note that this does not modify the given list but
 * returns a copy.
 *
 * @param {Record<string, any>[]} list
 * @param {Record<string, any>} entry
 * @param {string} identifierKey
 */
export function addOrUpdateObjectInList(list, entry, identifierKey) {
  let copiedList = [...list];
  const listOfUniqueIdentifiers = list.map((m) => m[identifierKey]);
  if (!listOfUniqueIdentifiers.includes(entry[identifierKey])) {
    if (entry.deleteTTL === undefined || entry.deleteTTL === null) {
      copiedList.push(entry);
    }
  } else {
    // Existing entry...update in place
    copiedList = list.map((obj) =>
      obj[identifierKey] === entry[identifierKey] ? entry : obj
    );
  }
  return copiedList;
}


/**
 * Given a list of unique values (strings, numbers), safely insert the entry
 * if it is not found within list. Returns a new list if appended.
 * 
 * @param {(string|number)[]} list 
 * @param {(string|number)} entry 
 * @returns  {(string|number)[]}
 */
export function addUniqueToList(list, entry) {
  if (!list.includes(entry)) {
    return [...list, entry]
  }

  return list
}